import clsx from 'clsx';
import React from 'react';

type Props = {
  title: string;
  size: 'sm' | 'md' | 'lg';
  type: 'default' | 'success' | 'warning' | 'danger';
  className?: any;
};

export default function Badge({ title, size, type, className }: Props) {
  return (
    <>
      <span
        className={clsx({
          'bg-blue-100 text-blue-800': type === 'default',
          'bg-[#77E7CC] text-[#00B388]': type === 'success',
          'bg-[#FF4E75] text-white': type === 'danger',
          'bg-yellow-100 text-yellow-800': type === 'warning',
          'text-xs ': size === 'sm',
          'text-sm': size === 'md',
          'text-lg': size === 'lg',
          [className]: className,
          'w-[80px] inline-flex items-center flex-col text-center rounded px-[1rem] py-[0.3rem] font-medium ':
            true
        })}
      >
        {title}
      </span>
    </>
  );
}
